import queryUtils from '../../../utils/agGridUtils/queryUtils';
import services from '../../../services';

export async function handleSearchQueryChange(api, request, searchQuery) {
  const query = queryUtils.getQueryParams(api, request, searchQuery);
  const response = await services.tenants.getByQuery(query);
  return queryUtils.parseResponse(response);
}
